<div *ngIf="modo==='normal'">
  <div class="conteiner">
    <div class="endbox">
      <div class="contenidoend">
        <div class="check-circle">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="titule">
          ¡Gracias por tu compra!
        </div>
        <div class="mintitle">
          Recibiste la confirmación en tu celular y en tu mail, con un recordatorio para que retires tu pedido.
        </div>
        <div class="botns">
          <div class="redirect-message">
            Será redireccionado al inicio en {{countdown}} segundos...
          </div>
          <button (click)="volverAchan()" onclick="window.scrollTo(0,0)" class="buttonpc blubutton noselect">
            Volver a Inicio
          </button>
        </div>

      </div>

    </div>

  </div>
  <mmax-helpfootbar [mode]="'flotante'"></mmax-helpfootbar>
</div>
